export default "__VITE_PUBLIC_ASSET__de66072b__"